import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LoadingSpinner } from "../LoadingSpinner";

export const AuthenticationRequired = () => {
  const { isLoggedIn, isAutheticatedByServer } = useAuth();

  if (!isLoggedIn) return <Navigate to="/signin" />;

  if (!isAutheticatedByServer){
    return (
        <div className="flex h-full w-full items-center justify-center">
             <LoadingSpinner size="40px" />
        </div>
    );
  }
  
  return <Outlet />;
};
